// Route watchers may observe a destination already selected by the user.
export function replaceIfChanged(router, target, options = {}) {
  const pending = router.history && router.history.pending;
  if (options.background && pending && pending.fullPath !== router.currentRoute.fullPath) return Promise.resolve();
  if (router.resolve(target).route.fullPath === router.currentRoute.fullPath) return Promise.resolve();
  return router.replace(target).catch(error => {
    if (error && ['NavigationDuplicated', 'NavigationCancelled', 'NavigationRedirected'].includes(error.name)) return;
    throw error;
  });
}

// Keep titles as router query values: #, &, + and ? are content, not URL syntax.
export function searchMenuLocation(menu, catalog, title) {
  const entry = (catalog || []).find(item => item.id === menu.id);
  const type = (entry && entry.recipeSetTypes || []).find(value => ['special', 'partner'].includes(value));
  const name = type === 'special' ? 'ReceipesSpecial' : type === 'partner' ? 'ReceipesSpecialPartner' : 'ReceipesRegular';
  return { name, params: { id: menu.id }, query: { back_search: 't', search: title || '', set: 'all' } };
}

// Close only the recipe overlay; preserve the underlying menu/search state.
export function withoutRecipeQuery(query) {
  const result = { ...query };
  for (const key of ['recipe_id', 'date', 'type', 'menu', 'meal_id', 'set_meal_id', 'subscription_id', 'user_recipe_set_id']) delete result[key];
  return result;
}
